// eslint-disable-next-line import/prefer-default-export
export const queryString = (params) =>
  Object.keys(params)
    .reduce((acc, k) => {
      if (!params[k]) return acc;
      return [...acc, k];
    }, [])
    .map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`)
    .join('&');
